export const recruitmentFTs = {
  googleLogin: { dev: true, sit: false, uat: true, prod: true },
}